// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInCreateNewAccountStyles } from "@ces/Overrides/Widgets/SignIn/SignInCreateNewAccount";
import { xScreen } from "@ces/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

signInCreateNewAccountStyles.mainContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: center;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    gap: 20,
    css: css`
        && {
            max-width: 430px;

            ${xScreen("lt", "md")} {
                max-width: 100%;
            }
        }
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTitleGridItem = {
    width: 12,
    css: css`
        padding: 8px 10px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    width: 12,
    css: css`
        padding: 8px 10px;
    `,
};

signInCreateNewAccountStyles.signInCreateNewAccountText = {
    color: "common.ui6",
    size: 14,
    lineHeight: "22px",
};

signInCreateNewAccountStyles.signInCreateNewAccountButtonGridItem = {
    width: 12,
    css: css`
        padding: 12px 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        padding: 12px 10px 0;
                        flex-direction: column;
                    `,
                    css`
                        padding: 12px 10px 0;
                    `,
                    css`
                        padding: 12px 10px 0;
                        flex-direction: row;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: space-between;
                    `,
                ],
                "min",
            )};
    `,
};

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "tertiary",
    css: css`
        height: 33px;
    `,
};
